export function getApiUrl() {
  return import.meta.env.VITE_API_URL;
}

export function isDev(): boolean {
  return !import.meta.env.NODE_ENV || import.meta.env.NODE_ENV === 'development';
}

export function getUiVersion() {
  return import.meta.env.VITE_UI_VERSION;
}
